import React, { useState, useEffect, useRef } from "react";
import { IoClose, IoMenu } from "react-icons/io5";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { getToken, deleteToken } from "../services/cookies"; // ← Düzeltildi
import { getUserProfile } from "../services/api"; // ← Düzeltildi
import { useTranslation } from "react-i18next";
import { FaCheckCircle, FaCheck } from "react-icons/fa";
import { CircleFlagLanguage } from "react-circle-flags";

export default function QriendNavbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const toggleMobile = () => setMobileOpen(!mobileOpen);

  const location = useLocation();
  const navigate = useNavigate();
  const isHome = location.pathname === "/";
  const { t, i18n } = useTranslation(); // ← Eklendi
  const [ready, setReady] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userData, setUserData] = useState(null);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isLangDrawerOpen, setIsLangDrawerOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Dil seçenekleri
  const languages = [
    { code: "tr", name: "Türkçe", flag: "https://flagcdn.com/tr.svg" },
    { code: "en", name: "English", flag: "https://flagcdn.com/gb.svg" },
    { code: "fr", name: "Français", flag: "https://flagcdn.com/fr.svg" },
    { code: "bg", name: "Български", flag: "https://flagcdn.com/bg.svg" },
    { code: "el", name: "Ελληνικά", flag: "https://flagcdn.com/gr.svg" },
    { code: "es", name: "Español", flag: "https://flagcdn.com/es.svg" },
    { code: "it", name: "Italiano", flag: "https://flagcdn.com/it.svg" },
    { code: "ru", name: "Русский", flag: "https://flagcdn.com/ru.svg" },
  ];

  // Mevcut dili bul
  const currentLanguage =
    languages.find((lang) => lang.code === i18n.language) || languages[0];

    useEffect(() => {
      const token = getToken("qriendtoken");
      if (token) {
        setIsLoggedIn(true);
      } else {
        setIsLoggedIn(false);
      }
    }, []);



  useEffect(() => {
    const token = getToken("qriendtoken");
    if (token) {
      setIsLoggedIn(true);   
    } else {
      setIsLoggedIn(false);
      setUserData(null);
    }
    setReady(true); // Token yoksa da ready yap

  }, []);


  const handleLogout = () => {
    deleteToken("qriendtoken");
    // localStorage'dan name'i de sil
    localStorage.removeItem("name");
    setIsLoggedIn(false);
    setUserData(null);
    setIsDropdownOpen(false);
    navigate("/", { replace: true });
  };

  // Dil değiştirme fonksiyonu
  const handleLanguageChange = (languageCode) => {
    i18n.changeLanguage(languageCode);
  };

  // localStorage'dan name'i al, fallback olarak kullan
  const storedName = localStorage.getItem("name");
  
  const userDisplayName =
    userData?.firstname && userData?.lastname
      ? `${userData.firstname} ${userData.lastname}`
      : userData?.firstname || userData?.name || storedName || "Kullanıcı";

  return (
    <>
    {ready && (
      <nav className=" xl:px-24 w-full bg-transparent absolute top-0 left-0 right-0 z-[9999] font-semibold px-4 py-4 md:px-8 lg:px-16">
        <div className="max-w-7xl mx-auto flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <img
              src={
                mobileOpen
                  ? "/assets/qriendLogoWhiteNew.png"
                  : isHome
                  ? "/assets/qriendLogoWhiteNew.png"
                  : "/assets/qriendLogoWhiteNew.png"
              }
              alt="QRIEND"
              className="h-12 md:h-14 lg:h-16 xl:h-20 w-auto object-contain"
              loading="lazy"
            />
          </Link>

          {/* Desktop Links */}
          <div className="hidden md:flex font-normal font-poppins items-center space-x-8 text-lg">
            <Link
              to="/discover"
              className={`transition-colors ${
                isHome
                  ? "text-black hover:text-white"
                  : "text-white hover:text-gray-300"
              }`}
            >
              {t("Discover")}
            </Link>
            <Link
              to="/leave-mark"
              className={`transition-colors ${
                isHome
                  ? "text-black hover:text-white"
                  : "text-white hover:text-gray-300"
              }`}
            >
              {t("LeaveMark")}
            </Link>
            <Link
              to="/contact"
              className={`transition-colors ${
                isHome
                  ? "text-black hover:text-white"
                  : "text-white hover:text-gray-300"
              }`}
            >
              {t("ContactTitle")}
            </Link>
            <Link
              to="/download"
              className={`bg-gradient-to-r from-[#BC1D8F] to-[#FF3F59] bg-clip-text font-poppins text-transparent font-semibold transition-colors hover:text-white`}
            >
              {t("InstallNow")}
            </Link>
          </div>

          {/* Auth Area (Desktop) */}
          <div className="hidden md:flex items-center space-x-4">
            {/* Mobil Dil Seçici Butonu */}
            <div className="relative">
              <button
                onClick={() => setIsLangDrawerOpen(true)}
                className={`text-sm font-medium font-poppins px-6 py-2 rounded-full transition-colors
                    ${
                      isHome
                        ? "bg-white text-[#E94057] border border-[#E94057] hover:bg-gray-100"
                        : "bg-transparent text-white border border-white hover:bg-white hover:text-black"
                    }
                  `}
              >
                {currentLanguage.code.toUpperCase()}
              </button>
            </div>

            {isLoggedIn  ? (
              <div className="relative" ref={dropdownRef}>
                <button
                  onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                  className="group flex items-center justify-center focus:outline-none bg-[#E94057] hover:bg-[#FFFFFF] w-36 h-10 rounded-full text-white"
                >
                  <span className="text-white group-hover:text-[#E94057] mr-2">
                    {ready ? userDisplayName : ""}
                  </span>
                  
                  <svg
                    className={`w-4 h-4 text-white group-hover:text-[#E94057] transition-transform transform ${
                      isDropdownOpen ? "rotate-180" : ""
                    }`}
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                      clipRule="evenodd"
                    ></path>
                  </svg>
                </button>
                {isDropdownOpen && (
                  <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg py-1 z-50 ring-1 ring-black ring-opacity-5">
                    <button
                      onClick={handleLogout}
                      className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                    >
                      {t("LogOut")}
                    </button>
                  </div>
                )}
              </div>
            ) : (
              <>
                <Link to="/login" className="w-fit">
                  <button
                    className={`text-sm font-medium font-poppins px-6 py-2 rounded-full transition-colors ${
                      isHome
                        ? "bg-white text-[#E94057] hover:bg-gray-100"
                        : "bg-transparent text-white hover:bg-white hover:text-black border border-white"
                    }`}
                  >
                    {t("Login")}
                  </button>
                </Link>
                <Link to="/register" className="w-fit">
                  <button
                    className={`text-sm font-medium font-poppins px-6 py-2 rounded-full transition-colors ${
                      isHome
                        ? "bg-[#E94057] text-white hover:bg-red-600"
                        : "bg-[#E94057] text-white hover:bg-red-600"
                    }`}
                  >
                    {t("Register")}
                  </button>
                </Link>
              </>
            )}
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden flex items-center space-x-3">
            {/* Mobil Dil Seçici Butonu */}
            <button
              onClick={() => setIsLangDrawerOpen(true)}
              className={`text-sm font-medium font-poppins px-6 py-2 rounded-full transition-colors
                  ${
                    isHome
                      ? "bg-white text-[#E94057] border border-[#E94057] hover:bg-gray-100"
                      : "bg-transparent text-white border border-white hover:bg-white hover:text-black"
                  }
                `}
            >
              {currentLanguage.code.toUpperCase()}
            </button>

            {/* Mobil Menü Butonu */}
            <button onClick={toggleMobile} className="flex items-center">
              {mobileOpen ? (
                <IoClose
                  className={`h-6 w-6 ${isHome ? "text-white" : "text-white"}`}
                />
              ) : (
                <IoMenu
                  className={`h-6 w-6 ${isHome ? "text-white" : "text-white"}`}
                />
              )}
            </button>
          </div>
        </div>

        {/* Mobile Menu Panel */}
        {mobileOpen && (
          <div className="md:hidden bg-white bg-opacity-95 backdrop-blur-md mt-2 rounded-lg shadow-lg p-4 space-y-4">
            {/* Mobil Dil Değiştirme kaldırıldı */}
            {/* Diğer menü linkleri ve login/register butonları burada kalacak */}
            <Link
              to="/discover"
              onClick={toggleMobile}
              className="text-black block text-lg transition-colors"
            >
              {t("Discover")}
            </Link>
            <Link
              to="/leave-mark"
              onClick={toggleMobile}
              className="text-black block text-lg transition-colors"
            >
              {t("LeaveMark")}
            </Link>
            <Link
              to="/contact"
              onClick={toggleMobile}
              className="text-black block text-lg transition-colors"
            >
              {t("ContactTitle")}
            </Link>
            <Link
              to="/download"
              onClick={toggleMobile}
              className="block text-lg bg-gradient-to-r from-[#BC1D8F] to-[#FF3F59] bg-clip-text text-transparent font-semibold transition-colors hover:text-black"
            >
              {t("InstallNow")}
            </Link>
            {isLoggedIn ? (
              <div className="border-t pt-4 space-y-2">
                <div className="flex items-center mb-2">
                 
                  <span className="text-black font-semibold text-lg">
                    {userDisplayName}
                  </span>
                </div>
                <button
                  onClick={() => {
                    toggleMobile();
                    handleLogout();
                  }}
                  className="block w-full text-left px-4 py-2 text-base text-gray-700 hover:bg-gray-100 rounded-md"
                >
                  {t("LogOut")}
                </button>
              </div>
            ) : (
              <>
                <Link to="/login" onClick={toggleMobile} className="block">
                  <button className="w-full bg-white text-[#E94057] border-2 border-[#E94057] font-medium px-6 py-2 rounded-full hover:bg-gray-100 transition-colors">
                    {t("Login")}
                  </button>
                </Link>
                <Link to="/register" onClick={toggleMobile} className="block">
                  <button className="w-full bg-[#E94057] text-white font-medium px-6 py-2 rounded-full hover:bg-red-600 transition-colors">
                    {t("Register")}
                  </button>
                </Link>
              </>
            )}
          </div>
        )}

        {/* Sağdan çıkan dil seçici panel */}
        <div
          className={`fixed top-0 right-0 h-screen w-64 md:w-80 bg-[#ffffff] text-black p-4 z-50 flex flex-col 
                      transition-all duration-500 ease-in-out transform 
                      ${
                        isLangDrawerOpen
                          ? "translate-x-0 opacity-100"
                          : "translate-x-full opacity-0"
                      }`}
        >
          <div className="flex justify-between items-center pb-4 mb-6">
            <div className="text-lg text-gray-800 font-light">
              {t("SelectLanguage") || "Dil Seçiniz"}
            </div>
            <button
              onClick={() => setIsLangDrawerOpen(false)}
              className="text-xl border-0 hover:border-0 p-1 text-gray-800 bg-transparent hover:text-green-500 transition-colors duration-200"
            >
              {"> <"}
            </button>
          </div>

          <div className="flex flex-col space-y-3">
            {/* Her dil seçeneği için giriş animasyonu */}
            <div className="grid grid-cols-3 gap-x-4 gap-y-2 lg:gap-x-14 lg:gap-y-4">
              {languages.map((lang, idx) => (
                <div
                  key={lang.code}
                  className={`relative transform ${
                    isLangDrawerOpen
                      ? "translate-x-0 opacity-100"
                      : "translate-x-8 opacity-0"
                  }`}
                  style={{ transitionDelay: `${100 + idx * 50}ms` }}
                >
                  <button
                    onClick={() => {
                      handleLanguageChange(lang.code);
                      setIsLangDrawerOpen(false);
                    }}
                    className={`relative flex items-center justify-center p-2 rounded-full transition-all duration-200
                        ${
                          currentLanguage.code === lang.code
                            ? "border-2 border-green-500"
                            : "border border-gray-300"
                        }
                        bg-transparent hover:border-blue-400 hover:bg-[#f1f0f0]`}
                    aria-label={lang.name}
                  >
                    <CircleFlagLanguage
                      languageCode={lang.code === "en" ? "en-us" : lang.code}
                      height="35"
                    />
                    {currentLanguage.code === lang.code && (
                      <div className="absolute -top-1 -right-1 bg-green-500 rounded-full p-1">
                        <FaCheck size={14} className="text-white" />
                      </div>
                    )}
                  </button>
                </div>
              ))}
            </div>
            <div className="flex justify-center pt-10 items-center">
              <img
                src="/assets/languagesDark.png"
                alt="languages"
                className="w-full"
              />
            </div>
          </div>
        </div>

        {/* Arka plan karartması */}
        {isLangDrawerOpen && (
          <div
            className="fixed inset-0 bg-black bg-opacity-50 z-40 transition-opacity duration-500"
            style={{ opacity: isLangDrawerOpen ? "1" : "0" }}
            onClick={() => setIsLangDrawerOpen(false)}
          />
        )}
      </nav>
      )}
    </>
  );
}
